<template>
  <div id="login">
    <div class="box-login">
      <div class="card">
        <div class="card-body">
          <div class="text-center">
            <img
              style="width: 50px; height: 50px"
              src="../assets/image/suzuya.png"
              alt=""
              srcset=""
              class="mb-2 mt-2"
            />
            <h5 class="fw-semibold mt-2 text-uppercase font-monospace">
              Image Uploader
            </h5>
          </div>
          <div class="divider"></div>
          <form @submit.prevent="login">
            <div>
              <label for="exampleFormControlInput2">Username</label>
              <input
                type="text"
                class="form-control"
                required
                v-model="form.username"
                @keydown.enter="login"
              />
            </div>
            <div>
              <label for="exampleFormControlInput2">Password</label>
              <input
                type="password"
                class="form-control"
                required
                v-model="form.password"
                @keydown.enter="login"
              />
            </div>

            <div class="col-12 mt-2">
              <button
                type="button"
                style="width: 100%"
                class="btn btn-primary btn-sm"
                @click="login"
              >
                Masuk
              </button>
            </div>
            <div class="text-center mt-3">
              <p style="font-size: 13px" class="font-monospace">
                Copyright@SuzuyaGroup | 2024 | V.0.2
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    login() {
      this.$store.dispatch("Auth/login");
    },
  },
  computed: {
    form: {
      get() {
        return this.$store.state.Auth.form;
      },
      set(value) {
        this.$store.commit("Auth/SET_FORM", value);
      },
    },
  },
};
</script>
<style scoped>
#login {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  height: 100vh;
  background-color: #ececec;
}

.box-login {
  position: absolute;
  width: 30%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* TABLET DEVICE */
@media screen and (max-width: 1024px) {
  .box-login {
    width: 50%;
  }
}

/* HANDPHONE DEVICE */
@media screen and (max-width: 768px) {
  .box-login {
    width: 90%;
  }
}

* {
  margin: 0;
  padding: 0;
}
</style>
